import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiEdit2 } from 'react-icons/fi';
import RolePermissionEditor from './RolePermissionEditor';

export default function EditRole({ roleId, roleName, permissionNames, permissions }) {
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    return <>
        <button type="button" className="portal-button access-edit-role" ref={triggerRef} onClick={() => setOpen(true)}><FiEdit2 aria-hidden="true" />Edit permissions</button>
        {open && createPortal(<RolePermissionEditor roleId={roleId} roleName={roleName} permissionNames={permissionNames} permissions={permissions}
            triggerRef={triggerRef} onClose={() => setOpen(false)} />, document.body)}
    </>;
}
